/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Closeeditorbutton2Inputs */
/** @typedef {{}} Closeeditorbuttontitle3Inputs */
/** @typedef {{}} Confirmcloseeditor2Inputs */
/** @typedef {{}} Defaultexample1Inputs */
/** @typedef {{}} Openeditorbutton2Inputs */
/** @typedef {{ "background:darkgreen": NonNullable<unknown> }} Readme1Inputs */
/** @typedef {{}} Redirectlabel1Inputs */
/** @typedef {{}} Redirectplaceholder1Inputs */
/** @typedef {{}} Rulesreminder1Inputs */


export const closeeditorbutton2 = /** @type {(inputs: Closeeditorbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi l'editor`)
};

export const closeeditorbuttontitle3 = /** @type {(inputs: Closeeditorbuttontitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi l'editor Markdown`)
};

export const confirmcloseeditor2 = /** @type {(inputs: Confirmcloseeditor2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi davvero chiudere l'editor Markdown?

Le tue modifiche verranno perse se non hai copiato il contenuto.`)
};

export const defaultexample1 = /** @type {(inputs: Defaultexample1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciao!
Hello!

![](assets/perso_educajou.svg)

![](assets/brigit_et_komit.png)
Brigit & Komit
`)
};

export const openeditorbutton2 = /** @type {(inputs: Openeditorbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri l'editor online`)
};

export const readme1 = /** @type {(inputs: Readme1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`# MemoryMD

**MemoryMD** è un'applicazione libera e gratuita che permette di creare giochi di abbinamento a partire da un semplice testo in Markdown.

Si possono creare giochi che abbinano: testo, immagini o suoni. Sono possibili tutte le combinazioni: testo/testo, testo/immagine, testo/suono, immagine/suono, immagine/immagine, suono/suono.

## ⚙️ Funzionamento

Per utilizzare l'applicazione MemoryMD, bisogna creare un file Markdown con la questa sintassi:

- Si separa ogni carta con una riga vuota.
- Se si vogliono abbinare due elementi, si scrive il primo elemento su una riga, poi, a capo, si scrive il secondo elemento: usa la sintassi Markdown per scrivere il testo o inserire un'immagine.
- Se è presente una sola riga, invece di abbinare due elementi diversi, la carta verrà ripetuta due volte e quindi si tratterà di trovare la carta identica.

Si può testare l'editor online per capire come funziona  <!--BUTTON_OPEN_EDITOR-->

Per poter condividere il proprio Memory, bisogna mettere il contenuto in Markdown in un file online (ad esempio con CodiMD).

Il gioco del Memory sarà allora disponibile a questo indirizzo: \`https://memorymd.forge.apps.education.fr/#URL_DEL_FILE_MARKDOWN\`

<!--INPUT_MARKDOWN-->

Si può aggiungere un titolo e/o una consegna al proprio gioco di Memory.
- Per il titolo, si utilizza un titolo di livello 1 in Markdown
- Per la consegna, si utilizza un blocco di citazione

Si può anche utilizzare un file audio con una riga che inizia con \`audio: \` seguita dall'URL del proprio file.

## 👀 Esempi

- [Esempio base](https://memorymd.forge.apps.education.fr/#https://codimd.apps.education.fr/5cw7PygxR72Obz8K8mRwew) per capire la struttura di un Memory. [Vedi il sorgente](https://codimd.apps.education.fr/5cw7PygxR72Obz8K8mRwew) per poi creare il proprio Memory.
- [Esempio di Memory con suoni](http://memorymd.forge.apps.education.fr/#https://codimd.apps.education.fr/fk4QyJ7nSF6dHb1mHOzGag) e associazioni testo/suono e immagine/suono. [Vedi il sorgente](https://codimd.apps.education.fr/fk4QyJ7nSF6dHb1mHOzGag)

## 🚀 Funzionalità più avanzate

Si possono aggiungere funzionalità con un'intestazione YAML.

\`\`\`yaml
---
maths: true
wintext: Eccellente, hai risolte correttamente!
style: body${i?.["background:darkgreen"]}
---
\`\`\`

- \`maths: true\` permette di inserire formule matematiche in Latex
- \`wintext:\` permette di personalizzare il messaggio che appare quando si è completato il memory
- \`style:\` permette di aggiungere stili CSS personalizzati

## 🙋‍♀️ Contribuire

Grazie per il tuo interesse per MemoryMD! Ogni contributo è apprezzato!

- Non esitare a inviare un suggerimento per aggiungere una funzionalità, o a segnalare un bug. Per farlo, si possono utilizzare i [ticket](https://forge.apps.education.fr/memorymd/memorymd.forge.apps.education.fr/-/issues/new) dell'applicazione oppure inviare una [mail](forge-apps+guichet+memorymd-memorymd-forge-apps-education-fr-6780-issue-@phm.education.gouv.fr).
- Se vuoi contribuire al codice di MemoryMD, non esitare a consultare i ticket e a [contattare il responsabile del progetto](http://eyssette.forge.apps.education.fr/).

## 👩‍⚖️ Licenza

MemoryMD è distribuito con licenza MIT.

## 🙏 Crediti

MemoryMD è stato scritto a partire dal [Memory Game di Nate Wiley](https://codepen.io/natewiley/pen/BawOqL) con Licenza MIT.

È stato riscritto senza jQuery e rifattorizzato per modernizzare il codice e ottimizzarlo.

Questa riscrittura aggiunge inoltre le seguenti funzionalità:
- codice sorgente delle carte in Markdown, grazie alla libreria [marked.js](https://marked.js.org/)
- lettura di un file esterno in Markdown inserendo l'URL nell'hash
- adattamento automatico della dimensione del carattere in ogni carta, con la libreria [textFit](https://github.com/STRML/textFit/)
- possibilità di utilizzare testo, immagine o suono in una carta, con tutte le associazioni possibili: testo/immagine, testo/suono, immagine/suono …
- accesso a funzionalità più avanzate (Latex, stili CSS, personalizzazione del contenuto dell'interfaccia) con un'intestazione YAML nel proprio codice sorgente in Markdown.`)
};

export const redirectlabel1 = /** @type {(inputs: Redirectlabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia qui il link al tuo file, poi clicca su "OK" per aprire il tuo Memory:`)
};

export const redirectplaceholder1 = /** @type {(inputs: Redirectplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo URL`)
};

export const rulesreminder1 = /** @type {(inputs: Rulesreminder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`

**Regola 1**
Si separa ogni carta con una riga vuota.

**Regola 2**
Se si vogliono abbinare due elementi, si scrive il primo elemento su una riga, poi, a capo, si scrive il secondo elemento: usa la sintassi Markdown per scrivere il testo o inserire un'immagine.

**Regola 3**
Se è presente una sola riga, invece di abbinare due elementi diversi, la carta verrà ripetuta due volte e quindi si tratterà di trovare la carta identica.

**Regola 4**
Per inserire un'immagine, si usa la sintassi Markdown classica \`![](URL_dell_immagine)\`

**Regola 5**
Per inserire un file audio, si usa la seguente sintassi: \`audio: URL_DEL_FILE_AUDIO\`


`)
};